<template>
  <div class="header-ecosystem">
    <BaseDropdown :close-on-click="false" position="bottom-right" :offset="8">
      <template #activator>
        <button class="button" type="button">
          <BaseIconSvoi icon="fluent/grid-dots-20-filled" size="s" />
        </button>
      </template>

      <template #content="{ toggle }">
        <HeaderEcosystemMenu @close="toggle" />
      </template>
    </BaseDropdown>
  </div>
</template>

<script setup lang="ts">
  import { BaseDropdown } from '~/components/base-ui/dropdown'
  import { BaseIconSvoi } from '~/components/base-ui/icon'
  import { HeaderEcosystemMenu } from '~/components/layouts/header/ecosystem/index'
</script>

<style lang="scss" scoped>
  .header-ecosystem {
    .button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background-color: $color-default-white;
      border: 2px solid $color-light-gray;
      border-radius: 50%;
      transition: border-color $trans-default;
      box-shadow: 0 4px 20px 0 rgb(0 0 0 / 8%);

      @include hover-focus {
        cursor: pointer;
        border-color: $color-potato-60;
      }
    }

    .dropdown-content {
      display: grid;
      gap: 16px;
      width: 400px;
      padding: 32px;

      > .header {
        @extend %font-20, %font-weight-500;
      }

      > .svoi-button {
        width: 100%;
      }
    }
  }
</style>
